










import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: '',
  components: {
    AsyncMobileTechList: () => import('../async/m-tech-list.vue')
  },
  setup() {
    const show = ref<boolean>(false)
    const handleSetShow = (state: boolean) => (show.value = state)
    return {
      show,
      handleSetShow
    }
  }
})
